
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import ProtectedRoute from '../components/ProtectedRoute';
import ProtectedAdminRoute from '../components/ProtectedAdminRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const FlowerPage = lazy(() => import('../pages/flower/page'));
const PrerollsPage = lazy(() => import('../pages/prerolls/page'));
const VapesPage = lazy(() => import('../pages/vapes/page'));
const EdiblesPage = lazy(() => import('../pages/edibles/page'));
const ConcentratesPage = lazy(() => import('../pages/concentrates/page'));
const AccessoriesPage = lazy(() => import('../pages/accessories/page'));
const MerchPage = lazy(() => import('../pages/merch/page'));
const EducationPage = lazy(() => import('../pages/education/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const JoinPage = lazy(() => import('../pages/JoinPage'));
const LoginPage = lazy(() => import('../pages/LoginPage'));
const AccountSettings = lazy(() => import('../pages/AccountSettings'));
const AdminLogin = lazy(() => import('../pages/AdminLogin'));
const AdminDashboard = lazy(() => import('../pages/AdminDashboard'));
const AdminStrainManagement = lazy(() => import('../pages/AdminStrainManagement'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <ProtectedRoute><HomePage /></ProtectedRoute>,
  },
  {
    path: '/flower',
    element: <ProtectedRoute><FlowerPage /></ProtectedRoute>,
  },
  {
    path: '/prerolls',
    element: <ProtectedRoute><PrerollsPage /></ProtectedRoute>,
  },
  {
    path: '/vapes',
    element: <ProtectedRoute><VapesPage /></ProtectedRoute>,
  },
  {
    path: '/edibles',
    element: <ProtectedRoute><EdiblesPage /></ProtectedRoute>,
  },
  {
    path: '/concentrates',
    element: <ProtectedRoute><ConcentratesPage /></ProtectedRoute>,
  },
  {
    path: '/accessories',
    element: <ProtectedRoute><AccessoriesPage /></ProtectedRoute>,
  },
  {
    path: '/merch',
    element: <ProtectedRoute><MerchPage /></ProtectedRoute>,
  },
  {
    path: '/education',
    element: <ProtectedRoute><EducationPage /></ProtectedRoute>,
  },
  {
    path: '/events',
    element: <ProtectedRoute><EventsPage /></ProtectedRoute>,
  },
  {
    path: '/account',
    element: <ProtectedRoute><AccountSettings /></ProtectedRoute>,
  },
  {
    path: '/join',
    element: <JoinPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/admin-login',
    element: <AdminLogin />,
  },
  {
    path: '/admin',
    element: <ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>,
  },
  {
    path: '/admin-dashboard',
    element: <ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>,
  },
  {
    path: '/admin-strain-management',
    element: <ProtectedAdminRoute><AdminStrainManagement /></ProtectedAdminRoute>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
